import type { MessagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf } from './messagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf';
import type { MessagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo } from './messagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type MessagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagement = MessagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf & MessagingSendMessage201AllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo;
